import { FormikHelpers } from 'formik';

import { useFormContext } from 'context/FormContext';
import { useLoaderContext } from 'context/LoaderContext';
import { useFormMutation } from 'mutations/useFormMutation';
import { PermissoesProps } from 'pages/cadastro/permissoes/types';

export function useMutatePermissoes() {
    const { setContent } = useFormContext();
    const { mutate, isLoading } = useFormMutation();
    const { setLoader } = useLoaderContext();

    const onSubmit = (values: PermissoesProps, formik: FormikHelpers<PermissoesProps>) => {
        const submitValues = { ...values };

        submitValues.dsObservacao = submitValues.dsObservacao === '' ? null : submitValues.dsObservacao;

        setLoader(true);

        mutate(
            {
                url: '/gestao/grupousuario',
                idField: 'idGrupoUsuario',
                formData: submitValues,
                formik,
            },
            {
                onSuccess: ({ data }: any) => setContent(data.data),
                onSettled: () => setLoader(false),
            },
        );
    };

    return { onSubmit, isLoading };
}
